"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeeSourceProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _state = require("../state");
class FeeSourceProvider {
  constructor() {
    (0, _defineProperty2.default)(this, "name", "fee");
  }
  getValue(provider, source, arg, step) {
    return {
      async value() {
        let base = await (0, _state.resolveBigNumberishSourcable)(provider, [source.base], step);
        let multiplier = await (0, _state.resolveBigNumberishSourcable)(provider, [source.multiplier, 1], step);
        if (base) {
          let decimals;
          if (!source.ignoreDecimals) {
            decimals = await (0, _state.resolveBigNumberishSourcable)(provider, [arg === null || arg === void 0 ? void 0 : arg.decimals], step);
          }
          if (multiplier === null) {
            multiplier = "1";
          }
          let res = new _bignumber.default(base).times(multiplier);
          if (decimals) {
            res = res.div(`1e${decimals}`);
          }
          return res.toString(10);
        }
        return "";
      }
    };
  }
}
exports.FeeSourceProvider = FeeSourceProvider;
//# sourceMappingURL=FeeSourceProvider.js.map